import { VpChevronLeftIcon } from '@vtmn-play/icons/react'
import { useTranslation } from 'react-i18next'
import { Link, useMatch } from 'react-router'
import './go-back-link.scss'

export interface GoBackLinkProps {
  specificLink?: string
}

function GoBackLink({ specificLink }: Readonly<GoBackLinkProps>) {
  const { t } = useTranslation()
  const exactSeasonMatch = useMatch('/:season')
  const deepSeasonMatch = useMatch('/:season/*')
  const currentSeason = (deepSeasonMatch ?? exactSeasonMatch)?.params?.season ?? ''

  return (
    <Link
      className="go-back-link"
      data-testid="go-back_link"
      to={specificLink || `/${currentSeason}`}
      aria-label={t('aria-label.go-back-on-previous-page')}
    >
      <VpChevronLeftIcon aria-hidden="true" />
    </Link>
  )
}

export default GoBackLink
